import ServiceExec from '@/common/utils/ServiceExec';
import { businessCard } from '@/common/service/apiList';
import store from '@/store';
import { trackFeature } from '@/common/utils/retentionTracker';

export default {
  // 명함 등록
  saveCard: async ({ commit }, formData) => {
    const { status, data } = await ServiceExec.multiPost(businessCard.saveCard, formData);
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  // 260603/260625: AI 명함 생성. 응답 {candidates, sessionId, remaining}. 실패 시 빈 객체.
  aiGenerate: async ({ commit }, formData) => {
    const { status, data } = await ServiceExec.multiPost(businessCard.aiGenerate, formData);
    if (status !== ServiceExec.status.OK) return {};
    return data ?? {};
  },

  // 260814: 비동기 생성 시작 → {jobId, sessionId, remaining}. 실패 시 null.
  aiGenerateStart: async ({ commit }, formData) => {
    const { status, data } = await ServiceExec.multiPost(businessCard.aiGenerateAsync, formData);
    if (status !== ServiceExec.status.OK) return null;
    return data && data.jobId ? data : null;
  },

  // 260814: 생성 상태 폴링 → { status: GENERATING|DONE|FAILED, candidates?, error? }
  aiGenerateStatus: async ({ commit }, { jobId }) => {
    const userNo = store.getters['user/getUserData']?.userNo;
    if (!userNo || !jobId) return { status: 'FAILED', error: '' };
    const { status, data } = await ServiceExec.get(businessCard.aiGenerateStatus(userNo, jobId));
    // BE ServiceException(잡 없음/만료 등)=HTTP500+평문 → FAILED로 전환
    if (status !== ServiceExec.status.OK) return { status: 'FAILED', error: typeof data === 'string' ? data : '' };
    return data || { status: 'GENERATING' };
  },

  // 260625: AI 명함 생성권 잔액 {hasActiveSession, sessionId, remaining}
  aiBalance: async () => {
    const { status, data } = await ServiceExec.get(businessCard.aiBalance);
    if (status !== ServiceExec.status.OK) return { hasActiveSession: false, sessionId: null, remaining: 0 };
    return data ?? { hasActiveSession: false, sessionId: null, remaining: 0 };
  },

  // 내 명함 목록
  getMyCards: async ({ commit }) => {
    const userNo = store.getters['user/getUserData'].userNo;
    if (!userNo) return;
    const { status, data } = await ServiceExec.get(businessCard.getMyCards(userNo));
    if (status !== ServiceExec.status.OK) return;
    commit('setMyCards', data ?? []);
  },

  // 명함 상세
  getCardDetail: async ({ commit }, cardNo) => {
    const { status, data } = await ServiceExec.get(businessCard.getCard(cardNo));
    if (status !== ServiceExec.status.OK) return false;
    commit('setCardDetail', data);
    return true;
  },

  // 명함 수정
  updateCard: async ({ commit }, formData) => {
    const { status, data } = await ServiceExec.multiPost(businessCard.updateCard, formData);
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  // 명함 삭제
  deleteCard: async ({ commit }, { cardNo, userNo }) => {
    const { status } = await ServiceExec.delete(businessCard.deleteCard(cardNo, userNo));
    return status === ServiceExec.status.OK;
  },

  // 명함 받기
  receiveCard: async ({ commit }, { cardNo, receiverNo, senderNo }) => {
    const url = `${businessCard.receiveCard(cardNo)}?receiverNo=${receiverNo}&senderNo=${senderNo}`;
    const { status, data } = await ServiceExec.post(url);
    if (status === ServiceExec.status.OK) {
      trackFeature('message', cardNo);
    }
    return status === ServiceExec.status.OK && data;
  },

  // 받은 명함 목록
  getReceivedCards: async ({ commit }) => {
    const userNo = store.getters['user/getUserData'].userNo;
    if (!userNo) return;
    const { status, data } = await ServiceExec.get(businessCard.getReceivedCards(userNo));
    if (status !== ServiceExec.status.OK) return;
    commit('setReceivedCards', data ?? []);
  },

  // 받은 명함 삭제
  deleteReceivedCard: async ({ commit }, { cardNo, userNo }) => {
    const { status } = await ServiceExec.delete(businessCard.deleteReceivedCard(cardNo, userNo));
    return status === ServiceExec.status.OK;
  }
};
